class TextUtils {

  // Based on this gist, with some slight modifications: https://gist.github.com/jeffjohnson9046/9789876
  static toTitleCase(input = '') {
    const smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via|ft|in|mm|m|oz|kg|lb)$/i
    const unitsOfMeasure = /^(ft|in|lb|oz|m|cm|mm|kg|g)$/i

    const i = input.toLowerCase()
    return i.replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s\\/-]*/g, (match, index, title) => {
      if ((index > 0 && index + match.length !== title.length &&
          match.search(smallWords) > -1 && title.charAt(index - 2) !== ':' &&
          (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') &&
          title.charAt(index - 1).search(/[^\s-]/) < 0) ||
          match.search(unitsOfMeasure) > -1) {
        return match.toLowerCase()
      }

      if (match.substr(1).search(/[A-Z]|\../) > -1) {
        return match
      }

      return match.charAt(0).toUpperCase() + match.substr(1)
    })
  }

  static toSentenceCase(str) {
    if (!str) return '';
  
    // Preserve final period if it exists
    const hasFinalPeriod = str.trim().endsWith('.');
  
    // Trim leading/trailing special characters, but allow trailing period
    let textcase = str.trim().replace(/^[^A-Za-z0-9]+|[^A-Za-z0-9]+$/g, '');
  
    // Convert to lowercase
    textcase = textcase.toLowerCase();
  
    // Collapse multiple spaces into a single space
    textcase = textcase.replace(/\s+/g, ' ');
  
    // Capitalize first letter and after periods
    textcase = textcase.replace(/(^\w|(?:\.\s+)\w)/g, match => match.toUpperCase());
  
    // Restore final period if it was originally present
    if (hasFinalPeriod && !textcase.endsWith('.')) {
      textcase += '.';
    }
  
    return textcase;
  }
  

  static stripNonNumbers(uncleansedPhoneString) {
    return uncleansedPhoneString.replace(/\D/g, '')
  }

  static stripNonAlphaNumeric(uncleansedGiftCardString) {
    return uncleansedGiftCardString.replace(/[\W_]/g, '')
  }
}

export default TextUtils
